/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton'
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {  makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons//ExpandLess';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { InfoOutlined } from '@material-ui/icons';
import styled from 'styled-components';
import { useAuthContext } from '../../../authentication/Auth';
import app from '../../../authentication/firebaseStart';
import { FILTER_CONSTANT } from '../../../data/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      backgroundColor: "white"
    },
    "&.Mui-expanded": {
      backgroundColor: "#F3F6FA"
    }
  },
  MuiAccordionSummary: {
    "&.MuiAccordionSummary-root": {
      padding: "0px 8px",
    }
  },
  MuiAccordionDetails: {
    "&.MuiAccordionDetails-root": {
      padding: "0px 16px 8px"
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "white",
    '&:hover': {
      // backgroundColor: alpha(theme.palette.common.white, 0.25),
      // backgroundColor: "red",
      border: "1px solid lightblue"
    },
    marginLeft: 0,
    width: '110%',
    // [theme.breakpoints.up('sm')]: {
    //   marginLeft: theme.spacing(1),
    //   width: 'auto',
    // },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: "16px"
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    // [theme.breakpoints.up('sm')]: {
    //   width: '12ch',
    //   '&:focus': {
    //     width: '20ch',
    //   },
    // },
  },
}));

const InfoMsg = styled.span`
    color: rgba(0, 0, 0, 0.54);
    margin: 0;
    font-size: 12px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    margin-left:10px;
`

const firestore = app.firestore();

export default function FilterMenu({ anchorRef, openFilter, applyFilter, filters, excludeFilterItems, actions, filterDbName, updateSelectedFilter }) {
    const context = useAuthContext();
    const companyID = context.currentUser.claims.companyID;
    const maxOptionSelect = FILTER_CONSTANT.MAX_OPTION_SELECT;
    const classes = useStyles();
    const { t } = useTranslation()
    // filter dropdown (main component)
    const [open, setOpen] = useState(false); 
    const [filterItems, setFilterItems] = useState([]);

    // saved view dropdown
    const [selectViewArrow, setSelectViewArrow] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [savedFilters, setSavedFilters] = useState([]);
    const [filterName, setFilterName] = useState("");
    const [filterNameError, setFilterNameError] = useState("");

    // saved filters in JSON format
    const [savedFilterJson, setSavedFilterJson] = useState({});

    // disabled features due to limitation of firestore
    const [isMultiSelected, setIsMultiSelected] = useState(false);
    const [isRadioSelected, setIsRadioSelected] = useState(false);
    const [disabledOtherOptions, setDisabledOtherOptions] = useState({});

    // current selected filter or on dropdown change
    const [selectedFilters, setSelectedFilters] = useState({});
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    // const [selectedDBOptions, setSelectedDBOptions] = useState({});
    
    // filter options fetched from db
    const [filterOptionsFromDb, setFilterOptionsFromDb] = useState({});
    const [totalOptionsCount, setTotalOptionsCount] = useState({});
    const [searchInputValue, setSearchInputValue] = useState({});
    const [searchOnOpen, setSearchOnOpen] = useState([]);

    // loaders
    const [viewAllLoading, setViewAllLoading] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    // handling arrow icon of dropdown
    const handleIconClick = () => {
      if(selectViewArrow){
        setViewOpen(false);
        setSelectViewArrow(false);
      }
      else{
        setSelectViewArrow(true); 
        setViewOpen(true);
      }
    }

    const handleChange = (panel) => (e, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    // selecting previously saved filters
    const selectSavedFilterChange = (event, value) => {
      console.log(value);
      setFilterName(value);
      if(typeof savedFilterJson[value] != typeof undefined){
        let currentSelectedFilter = savedFilterJson[value];

        //disabled logic
        for(let item in currentSelectedFilter){
          if(filterItems.findIndex(i => i.dbKey == item) == -1){
            let disabledOption = disabledOtherOptions;
            disabledOption[item] = false;
            setDisabledOtherOptions(disabledOption);

            if(currentSelectedFilter[item].length >= 2)  setIsMultiSelected(false); 

            // clear if removed item was selected before
            currentSelectedFilter[item] = [];
            continue;
          }
          if(currentSelectedFilter[item].length == 1){
            let disabledOption = disabledOtherOptions;
            disabledOption[item] = true;
            setDisabledOtherOptions({...disabledOption});
          }
          else if(currentSelectedFilter[item].indexOf("ALL") > -1 || currentSelectedFilter[item].length == 2){
            setIsMultiSelected(true);
            let disabledOption = disabledOtherOptions;
            disabledOption[item] = false;
            setDisabledOtherOptions({...disabledOption});
          }
  
          if(currentSelectedFilter[item].indexOf("ALL") == -1 && currentSelectedFilter[item].length == maxOptionSelect){
            let disabledOption = disabledOtherOptions;
            disabledOption[item] = true;
            setDisabledOtherOptions({...disabledOption});
          }
          else if(currentSelectedFilter[item].length == maxOptionSelect + 1){
            let disabledOption = disabledOtherOptions;
            disabledOption[item] = true;
            setDisabledOtherOptions({...disabledOption});
          }
        }

        setSelectedFilters({...currentSelectedFilter});
      }
    }

    // fetching previously saved filters
    const fetchSavedFilters = async () => {
      try{
        let filtersData = (await firestore
                      .collection('tenants')
                      .doc(companyID)
                      .collection('Users')
                      .doc(context.currentUser.uid)
                      .collection("Preferences")
                      .doc(filterDbName)
                      .collection("Filter")
                      .get()).docs.map((doc) => doc.data());

          if(filtersData.length){
            let optionList = [];
            let json = {}
            for(let i=0; i<filtersData.length; i++){
              optionList.push(filtersData[i].filterName);
              json[filtersData[i].filterName] = filtersData[i].filters;
            }
            setSavedFilterJson(json);
            setSavedFilters(optionList)
          }
      }
      catch(err){
        console.log(err);
      }
    }

    // updating the autopredicted filter name
    const updateFilterName = () => {
      let newFilteName = "Unsaved View";
      let count = 0;
      while(true){
        if(savedFilterJson[newFilteName]){
          newFilteName = "Unsaved View "+ ++count;
        }
        else{
          break;
        }
      }
      setFilterName(newFilteName);
    }

    const updateFilter = (e, key, option, isRadio) => {
      updateFilterName();

      if(typeof option != typeof undefined){
        let currentFilters = selectedFilters;
        if(e.target.checked){
          
          if(option == "ALL"){
            let currentOptionsData = filterItems.filter(option => option.dbKey == key);
            let currentOptions = [];
            if(currentOptionsData[0].isDBDependent){
              currentOptions = filterOptionsFromDb[key];
            }
            else{
              currentOptions = currentOptionsData[0].options;
            }

            if(currentOptions.length > maxOptionSelect){
              currentFilters[key] = [];
              for(let i=0; i<maxOptionSelect; i++)
                currentFilters[key].push(currentOptions[i].value);
            }
            else{
              currentFilters[key] = currentOptions.map(option => option.value);
            }
          }


          if(!currentFilters[key]){
            currentFilters[key] = [];
          }
          if(isRadio){
            currentFilters = {};
            currentFilters[key] = [];
            setIsRadioSelected(true);
            setDisabledOtherOptions({});
            setIsMultiSelected(false);
          }
          // adding selected items
          currentFilters[key].push(option);
          setSelectedFilters({...currentFilters});

          // disabled logic
          if(option == "ALL" || currentFilters[key].length == 2){
            setIsMultiSelected(true);
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = false;
            setDisabledOtherOptions({...disabledOption});
          }
          else if(currentFilters[key].length == 1){
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = true;
            setDisabledOtherOptions({...disabledOption});
          }

          if(currentFilters[key].indexOf("ALL") == -1 && currentFilters[key].length == maxOptionSelect){
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = true;
            setDisabledOtherOptions({...disabledOption});
          }
          else if(currentFilters[key].length == maxOptionSelect + 1){
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = true;
            setDisabledOtherOptions({...disabledOption});
          }
        }
        else{
          if(option == "ALL"){
            currentFilters[key] = [];
          }
          else{
            let index = currentFilters[key].indexOf(option);
            if (index > -1) {
              currentFilters[key].splice(index, 1);
            }

            // removing all, if there
            index = currentFilters[key].indexOf("ALL");
            if (index > -1) {
              currentFilters[key].splice(index, 1);
            }
          }

          setSelectedFilters({...currentFilters});

          // disabled logic
          if(option == "ALL" || currentFilters[key].length == 1){
            setIsMultiSelected(false);
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = true;
            setDisabledOtherOptions({...disabledOption});
          }

          if(currentFilters[key].length == 0){
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = false;
            setDisabledOtherOptions({...disabledOption});
          }

          if(currentFilters[key].length == maxOptionSelect - 1){
            let disabledOption = disabledOtherOptions;
            disabledOption[key] = false;
            setDisabledOtherOptions({...disabledOption});
          }
        }
      }
      else{
        let currentFilters = selectedFilters;
        currentFilters[key] = e.target.value;
        setSelectedFilters({...currentFilters});
      }
    }

    const clearFilters = () => {
      setIsRadioSelected(false);
      setSelectedFilters({});
      setIsMultiSelected(false);
      setFilterName("");
      setDisabledOtherOptions({});
      setSearchInputValue({})
      setSearchOnOpen([]);
      // applyFilter of parent component
      applyFilter({}, true);
      updateSession({}, "");
    }

    const applyFilters = () => {
      // applyFilter of parent component
      console.log("applyFilters called 2");
      applyFilter(selectedFilters, true);
      updateSession(selectedFilters, filterName);
    }

    const updateSession = (currentSelectFilter, currentFilterName) => {
      // adding into the session
      let existingSessionFilters = sessionStorage.getItem("dashboardFilter");

      if(existingSessionFilters == null)    existingSessionFilters = {};
      else  existingSessionFilters = JSON.parse(existingSessionFilters);

      existingSessionFilters[filterDbName] = {
        filter: currentSelectFilter,
        filterName: currentFilterName
      };
      sessionStorage.setItem("dashboardFilter", JSON.stringify(existingSessionFilters));
    }

    const onSaveFilters = async () => {
      if(filterName.length == 0){
        setFilterNameError("Filter Name can not be empty");
      }
      else{
        setIsSaving(true);
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .doc(context.currentUser.uid)
          .collection("Preferences")
          .doc(filterDbName)
          .collection("Filter")
          .doc(filterName.replaceAll(" ", "_").toUpperCase())
          .set({
            filterName,
            filters: selectedFilters
          })

        fetchSavedFilters();
        setIsSaving(false);
      }
    }

    const startLoading = (getter, setter, key) => {
      let loadingDetails = getter;
      loadingDetails[key] = true;
      setter({...loadingDetails});
    }

    // clicked on fetchAll
    const fetchAllData = async dbKey => {
      startLoading(viewAllLoading, setViewAllLoading, dbKey);
      handleSearchInput("", dbKey);
      let response = await actions.fetchAll[dbKey](true);

      let updatedOptions = filterOptionsFromDb;
      let updatedcount = totalOptionsCount;
      let loadingStatus = viewAllLoading;

      updatedOptions[dbKey] = response.list;
      updatedcount[dbKey] = response.count;
      loadingStatus[dbKey] = false;
      
      setFilterOptionsFromDb(updatedOptions);
      setTotalOptionsCount(updatedcount);
      setViewAllLoading(loadingStatus);
    }

    const handleSearchInput = (value, dbKey) => {
      let inputs = searchInputValue;
      inputs[dbKey] = value;
      setSearchInputValue({...inputs});
    }

    // handled search feature
    const searchOptions = async (event, dbKey) => {
      if (event.key === 'Enter') {
        startLoading(viewAllLoading, setViewAllLoading, dbKey);

        if(!!searchInputValue[dbKey] && searchInputValue[dbKey].length > 0){
          console.log(searchInputValue[dbKey]);
          let response = await actions.search[dbKey](searchInputValue[dbKey].toUpperCase());
          console.log(response)
          let updatedOptions = filterOptionsFromDb;
          let loadingStatus = viewAllLoading;

          updatedOptions[dbKey] = response;
          loadingStatus[dbKey] = false;

          setFilterOptionsFromDb(updatedOptions);
          setViewAllLoading(loadingStatus);
        }
        else{
          let response = await actions.fetchAll[dbKey](false);

          let updatedOptions = filterOptionsFromDb;
          let updatedcount = totalOptionsCount;
          let loadingStatus = viewAllLoading;

          updatedOptions[dbKey] = response.list;
          updatedcount[dbKey] = response.count;
          loadingStatus[dbKey] = false;
          
          setFilterOptionsFromDb(updatedOptions);
          setTotalOptionsCount(updatedcount);
          setViewAllLoading(loadingStatus);
        }
        
      }
    }

    // fetching initial data
    const fetchInitialData = async () => {
      try{
        let promise = [];
        let keys = [];
        let updatedOptions = {};
        let updatedCount = {};
        let loadingStatus = {};
        for(let i=0; i<filterItems.length; i++ ){
          if(filterItems[i].isDBDependent && actions.fetchInitialData[filterItems[i].dbKey]){
            promise.push(actions.fetchInitialData[filterItems[i].dbKey](false));
            keys.push(filterItems[i].dbKey);
            loadingStatus[keys[i]] = true;
          }
        }
        let response = await Promise.all(promise);

        for(let i=0; i<response.length; i++){
          updatedOptions[keys[i]] = response[i].list;
          updatedCount[keys[i]] = response[i].count;
          loadingStatus[keys[i]] = false;
        }
        setFilterOptionsFromDb(updatedOptions);
        setTotalOptionsCount(updatedCount);
        setViewAllLoading(loadingStatus);
        if(searchOnOpen.length){
          searchOptions({ key: "Enter" }, searchOnOpen);
        }
        else{
          searchItems();
        }
      }
      catch(err){
        console.log(err);
      }
    }

    const getCheckBoxes = (opt, dbKey, radioBtn) => {
      if(radioBtn){
        return(
          <FormControlLabel 
            key={opt.value}
            data-testid={`${dbKey}-${opt.value}`}
            value={opt.value}
            control={<Radio
              data-testid={`${dbKey}-${opt.value}-checkbox`}
              color="default"
              style={!!selectedFilters[dbKey] && !!selectedFilters[dbKey].includes(opt.value) ? {color:"#0073e6"}:{color:"grey"}}
            />} 
            label={opt.label} 
          />
        )
      }
      else{
        return (
          <FormControlLabel 
            key={opt.value}
            data-testid={`${dbKey}-${opt.value}`}
            control={<Checkbox 
              data-testid={`${dbKey}-${opt.value}-checkbox`}
              color="default"
              style={!!selectedFilters[dbKey] && !!selectedFilters[dbKey].includes(opt.value) ? {color:"#0073e6"}:{color:"grey"}}
              checked={!!selectedFilters[dbKey] && selectedFilters[dbKey].includes(opt.value)} 
              onChange={(e) => updateFilter(e, dbKey, opt.value)} name={opt.value.toString()}
              disabled={
                isRadioSelected ? true :
                opt.value == "ALL" ? 
                (
                  isMultiSelected &&
                  !!disabledOtherOptions[dbKey] && 
                  !(!!selectedFilters[dbKey] && selectedFilters[dbKey].includes(opt.value))
                ) || isMultiSelected && !!selectedFilters[dbKey]?.length < 1
                :
                isMultiSelected &&
                !!disabledOtherOptions[dbKey] && 
                !(!!selectedFilters[dbKey] && selectedFilters[dbKey].includes(opt.value))
              }
            />} 
            label={opt.label} 
          />
        )
      }
    }

    const getMaxWarningText = (opt) => {
      const content = (
        <div style={{ display: "inline" }}>
          <span style={{marginLeft:"40px", verticalAlign: "middle"}}>
              <InfoOutlined style={{color: "#96ad05"}}/>
          </span>
          <InfoMsg>{t('filterMenu.maxLimit', {value: maxOptionSelect})}</InfoMsg>
        </div>
      )

      if(opt.isDBDependent && !!filterOptionsFromDb[opt.dbKey]){
        if(filterOptionsFromDb[opt.dbKey].length >= maxOptionSelect && selectedFilters[opt.dbKey].length >= maxOptionSelect) return content
        else return null;
      }
      else if(!opt.isDBDependent){
        if(opt.options.length >= maxOptionSelect && selectedFilters[opt.dbKey].length >= maxOptionSelect) return content;
        else return null;
      }
      else{
        return null
      }
    }

    const searchItems = async () => {
      for(let dbKey in searchInputValue){
        if(searchInputValue[dbKey].length > 0){
          startLoading(viewAllLoading, setViewAllLoading, dbKey);
          let response = await actions.search[dbKey](searchInputValue[dbKey].toUpperCase());
          let updatedOptions = filterOptionsFromDb;
          let loadingStatus = viewAllLoading;

          updatedOptions[dbKey] = response;
          loadingStatus[dbKey] = false;

          setFilterOptionsFromDb(updatedOptions);
          setViewAllLoading(loadingStatus);
        }
      }
    }

    const evaluateFilterItems = () => {
      let currentFilters = [...filters];
      for(let i=0; i<excludeFilterItems.length; i++){
        const index = currentFilters.findIndex(item => item.dbKey == excludeFilterItems[i]);
        console.log("excludeFilterItems ", excludeFilterItems[i], index);
        if(index > -1){
          currentFilters.splice(index, 1);
        }
      }
      setFilterItems(currentFilters);
    }

    // remove disable flag for excuded filter options
    // const removeDisableFlag = currentFilters => {
    //   for(let i in selectedFilters){
    //     if(currentFilters.findIndex(item => item.dbKey == i) == -1){
    //       // disabled feature
    //       let disabledOption = disabledOtherOptions;
    //       disabledOption[i] = false;
    //       setDisabledOtherOptions(disabledOption);

    //       if(selectedFilters[i].length >= 2)  setIsMultiSelected(false); 

    //       // clear if any was selected before
    //       selectedFilters[i] = [];
    //     }
    //   }
    //   console.log("applyFilters called 3");
    //   applyFilter(selectedFilters);
    // }

    useEffect(() => {
      // updateFilterName();
      if(updateSelectedFilter && JSON.stringify(updateSelectedFilter) != JSON.stringify(selectedFilters)){
        setSelectedFilters(updateSelectedFilter);
        applyFilter(updateSelectedFilter);
        updateSession(updateSelectedFilter, "Unsaved View");
        let disabledOption = {};
        setSearchInputValue({});
        setSearchOnOpen([]);
        setIsRadioSelected(false);
        for(let item in updateSelectedFilter){
          let currentOptionsData = filterItems.filter(option => option.dbKey == item);
          if(currentOptionsData.length && currentOptionsData[0].isRadio){
            setIsRadioSelected(true);
          }
          if(currentOptionsData.length && currentOptionsData[0].isDBDependent){
            let inputValue = {};
            inputValue[item] = updateSelectedFilter[item][0];
            setSearchInputValue(inputValue);
            setSearchOnOpen(item)
          }
          if(updateSelectedFilter[item].length == 1){
            disabledOption[item] = true;
          }
          setDisabledOtherOptions({...disabledOption});
        }
      }
    }, [updateSelectedFilter])

    useEffect(()=> {
      setOpen(openFilter);
      if(openFilter){
        evaluateFilterItems()
        setExpanded(false);
        fetchSavedFilters();
      }
    }, [openFilter]);

    useEffect(() => {
      if(filterItems.length){
        fetchInitialData();
      }
    }, [filterItems])

    useEffect(() => {
      evaluateFilterItems();
    }, [excludeFilterItems]);

    useEffect(() => {
      let state = false;
      for(let item in selectedFilters){
        if(selectedFilters[item] && selectedFilters[item].length > 0){
          state = true;
          break;
        }
      }
      setIsFilterSelected(state);
    }, [selectedFilters]);

    useEffect(() => {
      // fetching data from session
      let sessionFilterData = sessionStorage.getItem("dashboardFilter");
      if(sessionFilterData != null){
        sessionFilterData = JSON.parse(sessionFilterData)[filterDbName];

        if(sessionFilterData && sessionFilterData.filter && sessionFilterData.filterName){
          if(Object.keys(sessionFilterData.filter).length){
            setSelectedFilters({...sessionFilterData.filter});
            applyFilter(sessionFilterData.filter, true);
            if(sessionFilterData.filterName.length){
              setFilterName(sessionFilterData.filterName);
            }
          }
        }
      }
    }, []);


  return (
    <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" role={undefined} transition disablePortal style={{ zIndex: 1000, height: 0 }}>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
        >
          <Paper>
            <div style={{ width: 300, padding: "18px" }}>
                <div style={{ display: "flex"}}>
                  <h3>{t('filterMenu.title')}</h3>
                  <Button color='primary'
                    disabled={!isFilterSelected}
                    data-testid="save-btn"
                    onClick={onSaveFilters}
                    style={{ marginLeft: "auto", textTransform: "none", backgroundColor: 'transparent' }}>
                      {
                        isSaving ? 
                        <>
                          <img src={process.env.PUBLIC_URL + '/csv_export.gif'} style={{ width: 18, marginRight: 5 }} />
                          {t('filterMenu.button.saving')}
                        </> : t('filterMenu.button.save')
                      }
                    </Button>
                </div>
                <Autocomplete
                  data-testid="filter-view"
                  size='small'
                  freeSolo
                  disableClearable
                  open={viewOpen}
                  onOpen={(e) => { setSelectViewArrow(true); setViewOpen(true); }}
                  onClose={() => { setSelectViewArrow(false); setViewOpen(false); } }
                  popupIcon={<ExpandMoreIcon />}
                  options={savedFilters}
                  onChange={selectSavedFilterChange}
                  inputValue={filterName}
                  renderInput={(params) => (
                    <TextField {...params} margin="normal" variant="outlined" placeholder={t('filterMenu.selectViewPlaceholder')}
                    data-testid="filter-view-text"
                    error={filterNameError.length ? true : false}
                    helperText={filterNameError}
                    onChange={(e) => { setFilterName(e.target.value); setFilterNameError(""); }}
                    InputProps={{ ...params.InputProps,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton data-testid="filter-view-icon" onClick={handleIconClick}>
                                    {!selectViewArrow && <ExpandMoreIcon />}
                                    {selectViewArrow && <ExpandLessIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                  />
                  )}
                />
                {
                  filterItems.map(item => (
                    <Accordion 
                      key={item.dbKey}
                      expanded={expanded === item.dbKey} 
                      onChange={handleChange(item.dbKey)}
                      elevation={0} 
                      classes={{
                          root: classes.MuiAccordionroot
                      }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`${item.dbKey}a-content`}
                        id={`${item.dbKey}a-header`}
                        classes={{
                          root: classes.MuiAccordionSummary
                        }}
                      >
                        <Typography className={classes.heading} data-testid={item.dbKey}>
                          {
                            !!selectedFilters[item.dbKey] && selectedFilters[item.dbKey].length > 0 ?
                            <b>{item.header}</b>
                            :
                            item.header
                          } 
                          ({
                            item.isDBDependent && !!totalOptionsCount[item.dbKey] ? totalOptionsCount[item.dbKey] : item.totalOptions
                          })
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails classes={{
                          root: classes.MuiAccordionDetails
                      }}
                      style={{
                        overflowY: "scroll",
                        maxHeight: "200px"
                      }}>
                      <FormControl component="fieldset">
                        {
                          <>
                            {
                              item.isDBDependent && !!filterOptionsFromDb[item.dbKey] ?
                                <div className={classes.search}>
                                  <div className={classes.searchIcon}>
                                    <SearchIcon fontSize='small'/>
                                  </div>
                                  <InputBase
                                    data-testid={`${item.dbKey}-searchInp`}
                                    placeholder={t('filterMenu.searchPlaceholder')}
                                    classes={{
                                      root: classes.inputRoot,
                                      input: classes.inputInput,
                                    }}
                                    inputProps={{ 'aria-label': 'search' }}
                                    value={!!searchInputValue[item.dbKey] ? searchInputValue[item.dbKey] : ""}
                                    onChange={(e) => handleSearchInput(e.target.value, item.dbKey)}
                                    onKeyDown={(e) => searchOptions(e, item.dbKey)}
                                  />
                                </div> : null
                            }
                            <FormGroup>
                              { 
                                !item?.isRadio && getCheckBoxes({ label: t('filterMenu.selectAll'), value:"ALL" }, item.dbKey) 
                              }
                              { 
                                !!selectedFilters[item.dbKey] && getMaxWarningText(item)
                              }
                              {
                                item.isDBDependent && !!filterOptionsFromDb[item.dbKey] ? 
                                  filterOptionsFromDb[item.dbKey] .map(opt => getCheckBoxes(opt, item.dbKey)) 
                                  :
                                  item?.isRadio ? 
                                  <>
                                    <RadioGroup
                                      aria-labelledby="demo-controlled-radio-buttons-group"
                                      name="controlled-radio-buttons-group"
                                      value={!!selectedFilters[item.dbKey] && selectedFilters[item.dbKey][0]}
                                      onChange={(e) => updateFilter({target: { checked: true }}, item.dbKey, e.target.value, true)}
                                    >
                                      { item.options.map(opt => getCheckBoxes(opt, item.dbKey, true)) }
                                    </RadioGroup>
                                  </>
                                  :
                                  item.options.map(opt => getCheckBoxes(opt, item.dbKey)) 
                              }
                            </FormGroup>
                            { 
                              item.isRadio ?
                              <div 
                                data-testid={`${item.dbKey}-clear`}
                                onClick={() => { setSelectedFilters({}); setIsRadioSelected(false); }} 
                                style={{ cursor: "pointer", color: "#4a5bb9", fontWeight: "600", paddingBottom: "8px" }}>{t('filterMenu.clear')}</div> : null
                            }
                            { 
                              item.isDBDependent && !viewAllLoading[item.dbKey] 
                                && !!totalOptionsCount[item.dbKey] && !!filterOptionsFromDb[item.dbKey] 
                                && totalOptionsCount[item.dbKey] > filterOptionsFromDb[item.dbKey].length ? 
                              <div 
                                data-testid={`${item.dbKey}-fetchAll`}
                                onClick={() => fetchAllData(item.dbKey)} 
                                style={{ cursor: "pointer", color: "#4a5bb9", fontWeight: "600", paddingBottom: "8px" }}>{t('filterMenu.viewAll')}</div> : null
                            }
                            {
                              !!viewAllLoading[item.dbKey] ?
                              <div style={{ cursor: "pointer", color: "#4a5bb9", fontWeight: "600" }}>{t('filterMenu.loading')}</div> : null 
                            }
                          </>
                        }
                      </FormControl>
                      </AccordionDetails>
                    </Accordion>
                  ))
                }
                <Grid container direction="row">
                  <Grid item sm={6}>
                    <Button
                      disabled={!isFilterSelected}
                      data-testid="clearFilter-btn"
                      variant="contained"
                      color="primary"
                      onClick={clearFilters}
                      style={{
                        width: "93%",
                        marginLeft: "5px",
                        marginBottom: "10px",
                        marginTop: "5px",
                        backgroundColor: isFilterSelected ? "#D70015" : "#0000001f",
                        textTransform: "none",
                        fontWeight: "400"
                      }}
                    >
                      {t('filterMenu.button.clearFilter')}
                    </Button>
                  </Grid>
                  <Grid item sm={6}>
                    <Button
                      disabled={!isFilterSelected}
                      data-testid="apply-btn"
                      variant="contained"
                      color="primary"
                      onClick={applyFilters}
                      style={{
                        width: "93%",
                        marginLeft: "5px",
                        marginBottom: "10px",
                        marginTop: "5px",
                        backgroundColor: isFilterSelected ? "#0073E6" : "#0000001f",
                        textTransform: "none",
                        fontWeight: "400"
                      }}
                    >
                      {t('filterMenu.button.apply')}
                    </Button>
                  </Grid>
                </Grid>
            </div>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}